import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, type Observable } from 'rxjs';

import { SupportRequestComponent } from './support-request.component';

@Injectable()
export class SupportRequestService {
  readonly #modal = inject(NgbModal);

  public open(): Observable<unknown> {
    const modal = this.#modal.open(SupportRequestComponent, {
      centered: true,
      windowClass: 'your-trust-fullscreen-modal'
    });
    return from(modal.result.catch(() => false));
  }
}
